<template>
  <section v-if="!is_supplier" class="section-container">
    <div class="content-wrapper">
      <contentheading
          :button="$t('suppliers.add')"
          :title="$t('suppliers.title')"
          url="supplier_add"/>
      <div class="row">
        <div class="col-xl-12">
          <div id="accordion">
            <div class="card mb-1">
              <div class="card-header" id="headingOne">
                <h4 class="mb-0">
                  {{ $t('suppliers.filter') }}
                  <a class="text-inherit"
                     data-toggle="collapse"
                     data-target="#collapseOne"
                     aria-expanded="true"
                     aria-controls="collapseOne"
                     href="">
                    <i class="icon-arrow-down"></i>
                  </a>
                </h4>
              </div>
              <div class="collapse hide" id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body border-top">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto" v-if="warehouse_groups.length > 1">
                          <p class="form-control-plaintext mb-2">{{ $t('suppliers.group') }}</p>
                        </div>
                        <div :key="group.name" class="col-auto" v-for="group in warehouse_groups">
                          <div class="form-check mb-2">
                            <input
                                class="form-check-input"
                                :id="group.name"
                                :name="group.name"
                                type="checkbox"
                                :value="group.id"
                                v-model="filter_groups">
                            <label class="form-check-label" :for="group.name">{{ group.name }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <button class="btn btn-success mb-2" type="submit" @click="filter">
                            {{ $t('suppliers.search') }}
                          </button>
                          <button class="btn btn-outline-info mb-2" type="cancel" @click="clear_filters">{{ $t('suppliers.reset') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons v-if="!is_supplier"/>
                <search @make_search="make_search"/>
                <div class="table-responsive">
                  <table id="suppliers" class="table table-striped dataTable my-4 w-100">
                    <thead>
                    <tr>
                      <th v-if="!is_supplier">
                        <div class="checkbox c-checkbox">
                          <label class="mb-0 p">
                            <input class="select-box" type="checkbox" v-model="selectAll">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'name',
                              'sorting_desc': ordering === '-name'}"
                          @click="order('name')">{{ $t('suppliers.company-name') }}
                      </th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'registration_code',
                              'sorting_desc': ordering === '-registration_code'}"
                          @click="order('registration_code')">{{
                          $t('suppliers.registration-code')
                        }}
                      </th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'country_code',
                              'sorting_desc': ordering === '-country_code'}"
                          @click="order('country_code')">{{ $t('suppliers.country') }}
                      </th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'email',
                              'sorting_desc': ordering === '-email'}"
                          @click="order('email')">{{ $t('suppliers.email') }}
                      </th>
                      <th>{{ $t('suppliers.groups') }}</th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'is_active',
                              'sorting_desc': ordering === '-is_active'}"
                          @click="order('is_active')">{{ $t('suppliers.status') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'active_users',
                          'sorting_desc': ordering === '-active_users'}"
                        @click="order('active_users')">
                        {{ $t('suppliers.active-and-non-active-users') }}
                      </th>
                      <th
                          :class="{
                              'sorting_asc': ordering === 'last_proposal_date',
                              'sorting_desc': ordering === '-last_proposal_date'}"
                          @click="order('last_proposal_date')">{{ $t('suppliers.last_proposal_date') }}
                      </th>
                      <th class="wd-xs"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(row, index) in rows"
                        :key="row.id"
                        :class="{'text-bold': row.is_new === true}"
                        class="gradeX">
                      <td v-if="!is_supplier">
                        <div class="checkbox c-checkbox">
                          <label class="mb-0">
                            <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                        <router-link
                            :title="$t('suppliers.edit')"
                            :to="{name: 'supplier_detail', params: {sup_id: row.id}}">
                          {{ row.name }}
                        </router-link>
                      </td>
                      <td>{{ row.registration_code }}</td>
                      <td>
                        <span v-for="(country, idx) in countries"
                          v-if="country.code == row.country_code"
                          :key="idx"
                          :value="country.code">
                          {{ country.name }}
                        </span>
                      </td>
                      <td>{{ row.email }}</td>
                      <td>{{ row.warehouse_groups_tags }}</td>
                      <td>{{ row.is_active ? 'Active' : 'Disabled' }}</td>
                      <td>
                        <span style="color: green">{{ row.active_users }}</span>
                        / <span style="color: red">{{ row.non_active_users }}</span>
                      </td>
                      <td>{{ row.last_proposal_date | formatDateTime }}
                        <span
                            v-if="format_date_time(row.last_proposal_date) !== format_date_time(row.last_proposal_date_updated)"
                            class="text-muted font-italic small"><br>{{ row.last_proposal_date_updated | formatDateTime }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group">
                          <router-link
                              :title="$t('suppliers.edit')"
                              :to="{name: 'supplier_edit', params: {id: row.id}}"
                              class="far fa-edit btn btn-link link-unstyled px-1 py-2 text-info">
                          </router-link>
                          <button :title="$t('suppliers.button-delete')"
                                  class="btn btn-link pl-1 pt-1 text-info"
                                  @click="remove_supplier(row.id, index)">
                            <i class="far fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination
                    :count="count"
                    :from="(page - 1) * page_size + 1"
                    :page="page"
                    :pages="pages"
                    :to="(page - 1) * page_size + rows.length"
                    @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import message from '@/message'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'
import moment from 'moment'
import XLSX from 'xlsx'

function calculateData(data) {
  let rowsData = []
  let rows = data
  let proposal_created = ''
  let proposal_updated = ''
  let proposalCreatedUpdated = ''
  rows.forEach(row => {

    if (row.last_proposal_date) {
      proposal_created = moment(String(row.last_proposal_date)).format('DD.MM.YYYY HH:mm')
    }
    if (row.last_proposal_date_updated) {
      proposal_updated = moment(String(row.last_proposal_date_updated)).format('DD.MM.YYYY HH:mm')
    }

    proposalCreatedUpdated = proposal_created

    if (proposal_created !== proposal_updated) {
      proposalCreatedUpdated += ' / ' + proposal_updated
    }

    rowsData.push({
      0: row.id,
      1: row.name,
      2: row.registration_code,
      3: row.country_code,
      4: row.email,
      5: row.warehouse_groups_tags,
      6: row.is_active ? 'Active' : 'Disabled',
      7: row.active_users + '/' + row.non_active_users,
      8: proposalCreatedUpdated
    })
  })
  return rowsData
}

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || '-id'
  const page = parseInt(route.query.page) || 1
  const groups = route.query.filter_groups

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/suppliers/?is_admin=true', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      filter_groups: groups,
      page_size: page_size
    }
  })
    .then(resp => {
      next({
        rows: resp.data.results,
        rowsData: calculateData(resp.data.results),
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    datatablebuttons: Datatablebuttons,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      rowsData: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      page_size: null,
      selected: [],
      filter_groups: [],
      countries: [
        {
          name: 'Afghanistan',
          code: 'AF'
        },
        {
          name: 'Åland Islands',
          code: 'AX'
        },
        {
          name: 'Albania',
          code: 'AL'
        },
        {
          name: 'Algeria',
          code: 'DZ'
        },
        {
          name: 'American Samoa',
          code: 'AS'
        },
        {
          name: 'AndorrA',
          code: 'AD'
        },
        {
          name: 'Angola',
          code: 'AO'
        },
        {
          name: 'Anguilla',
          code: 'AI'
        },
        {
          name: 'Antarctica',
          code: 'AQ'
        },
        {
          name: 'Antigua and Barbuda',
          code: 'AG'
        },
        {
          name: 'Argentina',
          code: 'AR'
        },
        {
          name: 'Armenia',
          code: 'AM'
        },
        {
          name: 'Aruba',
          code: 'AW'
        },
        {
          name: 'Australia',
          code: 'AU'
        },
        {
          name: 'Austria',
          code: 'AT'
        },
        {
          name: 'Azerbaijan',
          code: 'AZ'
        },
        {
          name: 'Bahamas',
          code: 'BS'
        },
        {
          name: 'Bahrain',
          code: 'BH'
        },
        {
          name: 'Bangladesh',
          code: 'BD'
        },
        {
          name: 'Barbados',
          code: 'BB'
        },
        {
          name: 'Belarus',
          code: 'BY'
        },
        {
          name: 'Belgium',
          code: 'BE'
        },
        {
          name: 'Belize',
          code: 'BZ'
        },
        {
          name: 'Benin',
          code: 'BJ'
        },
        {
          name: 'Bermuda',
          code: 'BM'
        },
        {
          name: 'Bhutan',
          code: 'BT'
        },
        {
          name: 'Bolivia',
          code: 'BO'
        },
        {
          name: 'Bosnia and Herzegovina',
          code: 'BA'
        },
        {
          name: 'Botswana',
          code: 'BW'
        },
        {
          name: 'Bouvet Island',
          code: 'BV'
        },
        {
          name: 'Brazil',
          code: 'BR'
        },
        {
          name: 'British Indian Ocean Territory',
          code: 'IO'
        },
        {
          name: 'Brunei Darussalam',
          code: 'BN'
        },
        {
          name: 'Bulgaria',
          code: 'BG'
        },
        {
          name: 'Burkina Faso',
          code: 'BF'
        },
        {
          name: 'Burundi',
          code: 'BI'
        },
        {
          name: 'Cambodia',
          code: 'KH'
        },
        {
          name: 'Cameroon',
          code: 'CM'
        },
        {
          name: 'Canada',
          code: 'CA'
        },
        {
          name: 'Cape Verde',
          code: 'CV'
        },
        {
          name: 'Cayman Islands',
          code: 'KY'
        },
        {
          name: 'Central African Republic',
          code: 'CF'
        },
        {
          name: 'Chad',
          code: 'TD'
        },
        {
          name: 'Chile',
          code: 'CL'
        },
        {
          name: 'China',
          code: 'CN'
        },
        {
          name: 'Christmas Island',
          code: 'CX'
        },
        {
          name: 'Cocos (Keeling) Islands',
          code: 'CC'
        },
        {
          name: 'Colombia',
          code: 'CO'
        },
        {
          name: 'Comoros',
          code: 'KM'
        },
        {
          name: 'Congo',
          code: 'CG'
        },
        {
          name: 'Congo, The Democratic Republic of the',
          code: 'CD'
        },
        {
          name: 'Cook Islands',
          code: 'CK'
        },
        {
          name: 'Costa Rica',
          code: 'CR'
        },
        {
          name: 'Cote D\'Ivoire',
          code: 'CI'
        },
        {
          name: 'Croatia',
          code: 'HR'
        },
        {
          name: 'Cuba',
          code: 'CU'
        },
        {
          name: 'Cyprus',
          code: 'CY'
        },
        {
          name: 'Czech Republic',
          code: 'CZ'
        },
        {
          name: 'Denmark',
          code: 'DK'
        },
        {
          name: 'Djibouti',
          code: 'DJ'
        },
        {
          name: 'Dominica',
          code: 'DM'
        },
        {
          name: 'Dominican Republic',
          code: 'DO'
        },
        {
          name: 'Ecuador',
          code: 'EC'
        },
        {
          name: 'Egypt',
          code: 'EG'
        },
        {
          name: 'El Salvador',
          code: 'SV'
        },
        {
          name: 'Equatorial Guinea',
          code: 'GQ'
        },
        {
          name: 'Eritrea',
          code: 'ER'
        },
        {
          name: 'Estonia',
          code: 'EE'
        },
        {
          name: 'Ethiopia',
          code: 'ET'
        },
        {
          name: 'Falkland Islands (Malvinas)',
          code: 'FK'
        },
        {
          name: 'Faroe Islands',
          code: 'FO'
        },
        {
          name: 'Fiji',
          code: 'FJ'
        },
        {
          name: 'Finland',
          code: 'FI'
        },
        {
          name: 'France',
          code: 'FR'
        },
        {
          name: 'French Guiana',
          code: 'GF'
        },
        {
          name: 'French Polynesia',
          code: 'PF'
        },
        {
          name: 'French Southern Territories',
          code: 'TF'
        },
        {
          name: 'Gabon',
          code: 'GA'
        },
        {
          name: 'Gambia',
          code: 'GM'
        },
        {
          name: 'Georgia',
          code: 'GE'
        },
        {
          name: 'Germany',
          code: 'DE'
        },
        {
          name: 'Ghana',
          code: 'GH'
        },
        {
          name: 'Gibraltar',
          code: 'GI'
        },
        {
          name: 'Greece',
          code: 'GR'
        },
        {
          name: 'Greenland',
          code: 'GL'
        },
        {
          name: 'Grenada',
          code: 'GD'
        },
        {
          name: 'Guadeloupe',
          code: 'GP'
        },
        {
          name: 'Guam',
          code: 'GU'
        },
        {
          name: 'Guatemala',
          code: 'GT'
        },
        {
          name: 'Guernsey',
          code: 'GG'
        },
        {
          name: 'Guinea',
          code: 'GN'
        },
        {
          name: 'Guinea-Bissau',
          code: 'GW'
        },
        {
          name: 'Guyana',
          code: 'GY'
        },
        {
          name: 'Haiti',
          code: 'HT'
        },
        {
          name: 'Heard Island and Mcdonald Islands',
          code: 'HM'
        },
        {
          name: 'Holy See (Vatican City State)',
          code: 'VA'
        },
        {
          name: 'Honduras',
          code: 'HN'
        },
        {
          name: 'Hong Kong',
          code: 'HK'
        },
        {
          name: 'Hungary',
          code: 'HU'
        },
        {
          name: 'Iceland',
          code: 'IS'
        },
        {
          name: 'India',
          code: 'IN'
        },
        {
          name: 'Indonesia',
          code: 'ID'
        },
        {
          name: 'Iran, Islamic Republic Of',
          code: 'IR'
        },
        {
          name: 'Iraq',
          code: 'IQ'
        },
        {
          name: 'Ireland',
          code: 'IE'
        },
        {
          name: 'Isle of Man',
          code: 'IM'
        },
        {
          name: 'Israel',
          code: 'IL'
        },
        {
          name: 'Italy',
          code: 'IT'
        },
        {
          name: 'Jamaica',
          code: 'JM'
        },
        {
          name: 'Japan',
          code: 'JP'
        },
        {
          name: 'Jersey',
          code: 'JE'
        },
        {
          name: 'Jordan',
          code: 'JO'
        },
        {
          name: 'Kazakhstan',
          code: 'KZ'
        },
        {
          name: 'Kenya',
          code: 'KE'
        },
        {
          name: 'Kiribati',
          code: 'KI'
        },
        {
          name: 'Korea, Democratic People\'S Republic of',
          code: 'KP'
        },
        {
          name: 'Korea, Republic of',
          code: 'KR'
        },
        {
          name: 'Kuwait',
          code: 'KW'
        },
        {
          name: 'Kyrgyzstan',
          code: 'KG'
        },
        {
          name: 'Lao People\'S Democratic Republic',
          code: 'LA'
        },
        {
          name: 'Latvia',
          code: 'LV'
        },
        {
          name: 'Lebanon',
          code: 'LB'
        },
        {
          name: 'Lesotho',
          code: 'LS'
        },
        {
          name: 'Liberia',
          code: 'LR'
        },
        {
          name: 'Libyan Arab Jamahiriya',
          code: 'LY'
        },
        {
          name: 'Liechtenstein',
          code: 'LI'
        },
        {
          name: 'Lithuania',
          code: 'LT'
        },
        {
          name: 'Luxembourg',
          code: 'LU'
        },
        {
          name: 'Macao',
          code: 'MO'
        },
        {
          name: 'Macedonia, The Former Yugoslav Republic of',
          code: 'MK'
        },
        {
          name: 'Madagascar',
          code: 'MG'
        },
        {
          name: 'Malawi',
          code: 'MW'
        },
        {
          name: 'Malaysia',
          code: 'MY'
        },
        {
          name: 'Maldives',
          code: 'MV'
        },
        {
          name: 'Mali',
          code: 'ML'
        },
        {
          name: 'Malta',
          code: 'MT'
        },
        {
          name: 'Marshall Islands',
          code: 'MH'
        },
        {
          name: 'Martinique',
          code: 'MQ'
        },
        {
          name: 'Mauritania',
          code: 'MR'
        },
        {
          name: 'Mauritius',
          code: 'MU'
        },
        {
          name: 'Mayotte',
          code: 'YT'
        },
        {
          name: 'Mexico',
          code: 'MX'
        },
        {
          name: 'Micronesia, Federated States of',
          code: 'FM'
        },
        {
          name: 'Moldova, Republic of',
          code: 'MD'
        },
        {
          name: 'Monaco',
          code: 'MC'
        },
        {
          name: 'Mongolia',
          code: 'MN'
        },
        {
          name: 'Montserrat',
          code: 'MS'
        },
        {
          name: 'Morocco',
          code: 'MA'
        },
        {
          name: 'Mozambique',
          code: 'MZ'
        },
        {
          name: 'Myanmar',
          code: 'MM'
        },
        {
          name: 'Namibia',
          code: 'NA'
        },
        {
          name: 'Nauru',
          code: 'NR'
        },
        {
          name: 'Nepal',
          code: 'NP'
        },
        {
          name: 'Netherlands',
          code: 'NL'
        },
        {
          name: 'Netherlands Antilles',
          code: 'AN'
        },
        {
          name: 'New Caledonia',
          code: 'NC'
        },
        {
          name: 'New Zealand',
          code: 'NZ'
        },
        {
          name: 'Nicaragua',
          code: 'NI'
        },
        {
          name: 'Niger',
          code: 'NE'
        },
        {
          name: 'Nigeria',
          code: 'NG'
        },
        {
          name: 'Niue',
          code: 'NU'
        },
        {
          name: 'Norfolk Island',
          code: 'NF'
        },
        {
          name: 'Northern Mariana Islands',
          code: 'MP'
        },
        {
          name: 'Norway',
          code: 'NO'
        },
        {
          name: 'Oman',
          code: 'OM'
        },
        {
          name: 'Pakistan',
          code: 'PK'
        },
        {
          name: 'Palau',
          code: 'PW'
        },
        {
          name: 'Palestinian Territory, Occupied',
          code: 'PS'
        },
        {
          name: 'Panama',
          code: 'PA'
        },
        {
          name: 'Papua New Guinea',
          code: 'PG'
        },
        {
          name: 'Paraguay',
          code: 'PY'
        },
        {
          name: 'Peru',
          code: 'PE'
        },
        {
          name: 'Philippines',
          code: 'PH'
        },
        {
          name: 'Pitcairn',
          code: 'PN'
        },
        {
          name: 'Poland',
          code: 'PL'
        },
        {
          name: 'Portugal',
          code: 'PT'
        },
        {
          name: 'Puerto Rico',
          code: 'PR'
        },
        {
          name: 'Qatar',
          code: 'QA'
        },
        {
          name: 'Reunion',
          code: 'RE'
        },
        {
          name: 'Romania',
          code: 'RO'
        },
        {
          name: 'Russian Federation',
          code: 'RU'
        },
        {
          name: 'RWANDA',
          code: 'RW'
        },
        {
          name: 'Saint Helena',
          code: 'SH'
        },
        {
          name: 'Saint Kitts and Nevis',
          code: 'KN'
        },
        {
          name: 'Saint Lucia',
          code: 'LC'
        },
        {
          name: 'Saint Pierre and Miquelon',
          code: 'PM'
        },
        {
          name: 'Saint Vincent and the Grenadines',
          code: 'VC'
        },
        {
          name: 'Samoa',
          code: 'WS'
        },
        {
          name: 'San Marino',
          code: 'SM'
        },
        {
          name: 'Sao Tome and Principe',
          code: 'ST'
        },
        {
          name: 'Saudi Arabia',
          code: 'SA'
        },
        {
          name: 'Senegal',
          code: 'SN'
        },
        {
          name: 'Serbia and Montenegro',
          code: 'CS'
        },
        {
          name: 'Seychelles',
          code: 'SC'
        },
        {
          name: 'Sierra Leone',
          code: 'SL'
        },
        {
          name: 'Singapore',
          code: 'SG'
        },
        {
          name: 'Slovakia',
          code: 'SK'
        },
        {
          name: 'Slovenia',
          code: 'SI'
        },
        {
          name: 'Solomon Islands',
          code: 'SB'
        },
        {
          name: 'Somalia',
          code: 'SO'
        },
        {
          name: 'South Africa',
          code: 'ZA'
        },
        {
          name: 'South Georgia and the South Sandwich Islands',
          code: 'GS'
        },
        {
          name: 'Spain',
          code: 'ES'
        },
        {
          name: 'Sri Lanka',
          code: 'LK'
        },
        {
          name: 'Sudan',
          code: 'SD'
        },
        {
          name: 'Suriname',
          code: 'SR'
        },
        {
          name: 'Svalbard and Jan Mayen',
          code: 'SJ'
        },
        {
          name: 'Swaziland',
          code: 'SZ'
        },
        {
          name: 'Sweden',
          code: 'SE'
        },
        {
          name: 'Switzerland',
          code: 'CH'
        },
        {
          name: 'Syrian Arab Republic',
          code: 'SY'
        },
        {
          name: 'Taiwan, Province of China',
          code: 'TW'
        },
        {
          name: 'Tajikistan',
          code: 'TJ'
        },
        {
          name: 'Tanzania, United Republic of',
          code: 'TZ'
        },
        {
          name: 'Thailand',
          code: 'TH'
        },
        {
          name: 'Timor-Leste',
          code: 'TL'
        },
        {
          name: 'Togo',
          code: 'TG'
        },
        {
          name: 'Tokelau',
          code: 'TK'
        },
        {
          name: 'Tonga',
          code: 'TO'
        },
        {
          name: 'Trinidad and Tobago',
          code: 'TT'
        },
        {
          name: 'Tunisia',
          code: 'TN'
        },
        {
          name: 'Turkey',
          code: 'TR'
        },
        {
          name: 'Turkmenistan',
          code: 'TM'
        },
        {
          name: 'Turks and Caicos Islands',
          code: 'TC'
        },
        {
          name: 'Tuvalu',
          code: 'TV'
        },
        {
          name: 'Uganda',
          code: 'UG'
        },
        {
          name: 'Ukraine',
          code: 'UA'
        },
        {
          name: 'United Arab Emirates',
          code: 'AE'
        },
        {
          name: 'United Kingdom',
          code: 'GB'
        },
        {
          name: 'United States',
          code: 'US'
        },
        {
          name: 'United States Minor Outlying Islands',
          code: 'UM'
        },
        {
          name: 'Uruguay',
          code: 'UY'
        },
        {
          name: 'Uzbekistan',
          code: 'UZ'
        },
        {
          name: 'Vanuatu',
          code: 'VU'
        },
        {
          name: 'Venezuela',
          code: 'VE'
        },
        {
          name: 'Viet Nam',
          code: 'VN'
        },
        {
          name: 'Virgin Islands, British',
          code: 'VG'
        },
        {
          name: 'Virgin Islands, U.S.',
          code: 'VI'
        },
        {
          name: 'Wallis and Futuna',
          code: 'WF'
        },
        {
          name: 'Western Sahara',
          code: 'EH'
        },
        {
          name: 'Yemen',
          code: 'YE'
        },
        {
          name: 'Zambia',
          code: 'ZM'
        },
        {
          name: 'Zimbabwe',
          code: 'ZW'
        }
      ],
      columns: [
        this.$i18n.t('suppliers.company-name'),
        this.$i18n.t('suppliers.registration-code'),
        this.$i18n.t('suppliers.country'),
        this.$i18n.t('suppliers.email'),
        this.$i18n.t('suppliers.groups'),
        this.$i18n.t('suppliers.status'),
        this.$i18n.t('suppliers.active-and-non-active-users'),
        this.$i18n.t('suppliers.last_proposal_date')
      ]
    }
  },
  computed: {
    warehouse_groups() {
      return JSON.parse(this.$store.getters.warehouse_groups)
    },
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  mounted () {
    this.$parent.menu = 'users'
    this.$parent.submenu = 'suppliers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    export_selected_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/suppliers/', {
          params: {
            ids: this.selected.join(','),
            page_size: 0
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    export_all_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/suppliers/', {
          params: {
            page_size: 0,
            search: this.search,
            ordering: this.ordering,
            filter_groups: this.filter_groups
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    format_date_time (dt) {
      return moment(String(dt)).format('DD.MM.YYYY HH:mm')
    },
    clear_filters() {
      this.filter_groups = []
      api.get('/suppliers/?is_admin=true', {
        params: {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_groups: this.filter_groups
        }
      })
          .then(response => {
            this.rows = response.data.results
            this.pages = response.data.pages
            this.count = response.data.count
            this.page = 1
          })
      this.$router.push({name: 'suppliers'}).catch(()=>{})
    },
    filter () {
      api.get('/suppliers/?is_admin=true', {
        params: {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_groups: this.filter_groups
        }
      }).then(response => {
        this.rows = response.data.results
        this.pages = response.data.pages
        this.count = response.data.count
        this.page = 1
      })

      this.$router.push({
        query:{
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_groups: this.filter_groups
        }
      })
    },
    remove_supplier (id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('suppliers.are-you-sure'),
        text: this.$i18n.t('suppliers.are-you-sure-text-cancel'),
        showCancelButton: true
      })
          .then((choice) => {
            if (choice.value) {
              api.post('/remove_supplier/', {
                supplier_id: id
              })
                  .then(() => {
                    message.success(this.$i18n.t('suppliers.account-deleted'))
                    this.$delete(this.rows, index)
                  })
                  .catch(() => {
                    message.error(this.$i18n.t('suppliers.forbidden'))
                  })
            }
          })
    },
    order(o) {
      this.$router.push({
        query: {
          search: this.search,
          ordering: o === this.ordering ? '-' + o : o,
          page: 1,
          page_size: this.page_size,
          filter_groups: this.filter_groups
        }
      })
    },
    paginate(p) {
      this.$router.push({
        query: {
          page: p.page,
          page_size: p.page_size,
          search: this.search,
          ordering: this.ordering,
          filter_groups: this.filter_groups
        }
      })
    },
    make_search() {
      this.$router.push({
        query: {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          filter_groups: this.filter_groups
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Suppliers.vue